import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
`;

export const InputContainerCourse = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
`;

export const InputContainerYear = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
`;

export const CourseDiv = styled.div`
  display: flex;
  gap: 20px;
`;
